<template>
  <div style="height: 800px; position: relative">
    <div v-if="loading" class="loading-div">
      <Button loading shape="circle" type="primary"></Button>
      <div>loading...</div>
    </div>
    <Table :columns="tableTitle" :data="tableData" border stripe height="750">
    </Table>
    <div class="total-bill">
      <div class="label">{{ $t("total") }}:</div>
      <div class="label">
        <div class="titel" v-for="(item, index) in totalData" :key="index">
          <span>
            {{
              index == "total"
                ? $t("bindFreight") + ":"
                : index.toUpperCase() + ":"
            }}
          </span>
          <span class="text-red">{{ item }} </span>
          <span>{{ index == "total" ? $t("items") : "" }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Detail } from "@/api/finance/airIncomeDetail";
import Details from "./details";
export default {
  inject: ["$page"],
  components: {
    Details,
  },
  props: {
    row: {
      type: Object,
    },
  },
  data() {
    return {
      totalData: {},
      categoryList: [],
      currency: "",
      type: "IN",
      tableData: [],
      total: 0,
      loading: true,
      dataDetails: {},
      conmanyList: [],
      itemList: [],
      chargingList: [],
      finance_remarks: "finance_remarks",
    };
  },
  computed: {
    tableTitle() {
      let columns = [];
      columns.push({
        type: "index",
        width: 65,
        align: "center",
        title: "#",
      });
      columns.push({
        title: this.$t("operate"),
        key: "operator_name",
        align: "center",
        width: 170,
        tooltip: true,
      });
      columns.push({
        title: this.$t("operation") + this.$t("time"),
        key: "create_time",
        align: "center",
        width: 170,
        tooltip: true,
      });
      columns.push({
        title: this.$t("incomeSubject"),
        key: "expense_item",
        align: "center",
        width: 115,
      });
      columns.push({
        title: this.$t("bubbleType"),
        key: "bubble",
        width: 100,
        align: "center",
      });
      columns.push({
        title: this.$t("quantity1"),
        align: "center",
        width: 110,
        key: "quantity",
      });
      columns.push({
        title: this.$t("doublePrice"),
        align: "center",
        width: 110,
        key: "price",
      });
      columns.push({
        title: this.$t("currencyCode"),
        align: "center",
        key: "currency",
        width: 100,
      });
      columns.push({
        title: this.$t("doubleAmount"),
        align: "center",
        key: "amount",
        width: 120,
      });
      columns.push({
        title: this.$t("order_desc"),
        align: "center",
        tooltip: "true",
        key: "remarks",
        minWidth: 95,
      });
      return columns;
    },
  },
  mounted() {
    this.SearchSubmit();
  },
  methods: {
    SearchSubmit() {
      this.loading = true;
      Detail(this.row.extract_id)
        .then((res) => {
          this.loading = false;
          if (!res.data.status) {
            this.$Message["error"]({
              background: true,
              content: res.data.msg,
              duration: 5,
            });
          } else {
            let data = res.data.payload;
            this.totalData = res.data.payload.total;
            this.tableData = data.rows;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="less" scoped>
.table-header {
  border: 1px solid #e8eaec;
  border-bottom: 0;
  padding: 14px 16px;
  line-height: 1;
  display: flex;
}
.total-bill {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #e8eaec;
  border-top: 0;
  font-weight: bold;
  padding: 0 10px;
  .label {
    display: flex;
    .titel {
      margin-left: 10px;
      .text-red {
        color: red;
        margin: 0 5px;
      }
    }
  }
}
</style>
